export default __webpack_public_path__ + "static/media/fad-loop.5ebf84b3.svg";